import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Button } from '@mui/material';
import { useState, useCallback } from 'react';

interface ResumeTicketDialogProps {
  open: boolean;
  onClose: () => void;
  onResume: (comments: string) => Promise<void>;
  isResuming: boolean;
}

export function ResumeTicketDialog({ open, onClose, onResume, isResuming }: ResumeTicketDialogProps) {
  const [comments, setComments] = useState('');
  
  const handleSubmit = useCallback(async () => {
    await onResume(comments);
    setComments('');
  }, [comments, onResume]);
  
  const handleClose = useCallback(() => {
    setComments('');
    onClose();
  }, [onClose]);
  
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Resume Ticket</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please provide a comment for resuming this ticket.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="comments"
          label="Resume Comments"
          type="text"
          fullWidth
          multiline
          rows={4}
          value={comments}
          onChange={(e) => setComments(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          color="primary" 
          disabled={isResuming}
        >
          {isResuming ? 'Resuming...' : 'Resume Ticket'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
